import { create } from "zustand";
import { createSelectors } from ".";
import { useStateActions } from "./hooks/useStateActions";

interface BrightbotStore {
  assistants: any[];
  activeAssistant: any;
  actions: {
    setAssistants: (assistants: any[]) => void;
    setActiveAssistant: (assistant: any) => void;
  };
}

const useBrightbotStoreBase = create<BrightbotStore>((set) => ({
  assistants: [],
  activeAssistant: "",
  actions: {
    setAssistants: (assistants) => {
      set({
        assistants,
      });
    },
    setActiveAssistant: (assistant) => {
      set({
        activeAssistant: assistant,
      });
    },
  },
}));

export const useBrightbotStore = createSelectors(useBrightbotStoreBase);
export const useBrightbotActions = () => useStateActions(useBrightbotStore);
